import { AsyncPipe, NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    inject,
} from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';
import { SIDEBAR_MENU } from '@features/navigation/navigation-menu-data';
import { LinkComponent } from '@shared/link/link.component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FaLogoComponent } from '../../../../shared/fa-logo/fa-logo.component';
import { ModalService } from '../../../modal/services/modal.service';
import { NavigationSidebarService } from '../../services/navigation-sidebar.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, LinkComponent, FaLogoComponent, AsyncPipe],
})
export class SidebarComponent implements OnInit {
    private navigationSidebarService = inject(NavigationSidebarService);
    private modalService = inject(ModalService);
    private environmentService = inject(EnvironmentService);

    @Input() isNavbarInverseColors: boolean;

    open: Observable<boolean>;
    modalActive: Observable<boolean>;
    readonly sidebarMenu = SIDEBAR_MENU;

    ngOnInit(): void {
        this.modalActive = this.modalService.active;
        this.open = this.navigationSidebarService.isOpen.pipe(
            map(isOpen =>
                this.environmentService.isBrowser() ? isOpen : false
            )
        );
    }

    hide() {
        this.navigationSidebarService.close();
    }
}
